import React, { useState, useEffect } from 'react';
import { Modal as ModalPopup } from 'react-bootstrap';
import { I18n } from '../../../helpers/i18n';
import client from '../../../helpers/client';
import mvpAuth from '../../../helpers/mvpAuth';
import { formatRating, maskUserName } from '../../../helpers/utils';
import RatingListItem from './RatingListItem';
import starActive from '../../../static/images/mvp/star_active.png';
import './RatingListModal.css';
import './TopicRatingListModal.css';


function TopicRatingListModal({ visible, topicId, onClose, totalScore, totalCount, initialRatings, isFromTopic = false, user }) {
  const [ratings, setRatings] = useState([]);
  const [loading, setLoading] = useState(false);

  const hasInitialData = initialRatings != null && Array.isArray(initialRatings);

  useEffect(() => {
    if (!visible) return;
    if (hasInitialData) return;
    if (topicId) {
      setLoading(true);
      client
        .sendRequest({
          path: 'mvp/list-data-evaluate-session-by-topic',
          method: 'GET',
          params: { topicId },
          headers: mvpAuth.getHeaderForMvp(),
        })
        .then(({ data: response }) => {
          setRatings(Array.isArray(response) ? response : []);
        })
        .catch(() => {
          setRatings([]);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setRatings([]);
    }
  }, [visible, topicId, hasInitialData]);

  const displayRatings = hasInitialData ? initialRatings : ratings;
  const displayScore = totalScore ?? 0;
  const displayCount = totalCount ?? 0;
  return (
    <ModalPopup size="lg" show={visible} onHide={onClose} id="rating-list-modal" className="topic-rating-modal" centered style={{ opacity: 1 }}>
      <div className="rating-list-modal-header">
        <span className="rating-list-modal-close" onClick={onClose}>
          ✕
        </span>
        <span className="rating-list-modal-header-title">
          {I18n.t('topic_ratings_title')}
        </span>
      </div>
      <ModalPopup.Body>
        <div className="rating-list-modal-content">
          {displayCount > 0 && (
            <div className="rating-list-summary">
              <img src={starActive} className="rating-list-summary-star-image" alt="" />
              <span className="rating-list-summary-score">{formatRating(displayScore)}</span>
              <span className="rating-list-summary-separator">•</span>
              <span className="rating-list-summary-count">
                {displayCount.toLocaleString()} {I18n.t('ratings_count')}
              </span>
            </div>
          )}

          {loading ? (
            <div className="rating-list-loading">...</div>
          ) : displayRatings.length === 0 ? (
            <div className="rating-list-empty">{I18n.t('no_rating')}</div>
          ) : (
            <div className="rating-list-items">
              {displayRatings.map((item, index) => (
                <RatingListItem
                  key={index}
                  roleLabel={item.role || I18n.t('account_type_selection_senior')}
                  name={maskUserName(item.name || user?.name || '')}
                  score={item.score}
                  time={item.time}
                  contentExtra={item.contentExtra}
                  content={item.content}
                />
              ))}
            </div>
          )}
        </div>
      </ModalPopup.Body>
    </ModalPopup>
  );
}

export default TopicRatingListModal;
